module.exports = {"211422100":"建昌镇","211422101":"八家子镇","211422102":"喇嘛洞镇","211422103":"药王庙镇","211422104":"汤神庙镇","211422105":"玲珑塔镇","211422106":"大屯镇","211422201":"牤牛营子乡","211422203":"素珠营子乡","211422204":"石佛乡","211422206":"王宝营子乡","211422207":"老大杖子乡","211422208":"要路沟乡","211422209":"魏家岭乡","211422210":"西碱厂乡","211422211":"头道营子乡","211422212":"新开岭乡","211422213":"贺杖子乡","211422214":"养马甸子乡","211422215":"和尚房子乡","211422218":"杨树湾子乡","211422219":"黑山科乡","211422220":"雷家店乡","211422222":"小德营子乡","211422223":"二道湾子蒙古族乡","211422224":"巴什罕乡","211422225":"娘娘庙乡","211422226":"谷杖子乡","211422401":"建昌飞地经济区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211422.json
// module id = 689
// module chunks = 0